import { render, staticRenderFns } from "./SmsMessageTemplates.vue?vue&type=template&id=22f5921f"
import script from "./SmsMessageTemplates.vue?vue&type=script&lang=js"
export * from "./SmsMessageTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports